import React from 'react';
import EIVHeader from './EIVHeader';
import { Button } from 'reactstrap'
import { CSS_CLASSNAME_PANEL } from './EIVCommons';
import Veranstaltungen from './components/Veranstaltungsliste';
import SpeichermodusHinweis from './components/SpeichermodusHinweis';
import AddVeranstaltungPanel from './AddVeranstaltungPanel'
import { setScreen } from './store/appNavigation/actions';
import { connect } from 'react-redux'
import { addVeranstaltungPanelSetVNR, addVeranstaltungPanelSetVNRPwd, setShowAddVeranslatungsPanel } from './store/veranstaltungen/actions';


const VeranstalterPage = (props) => {
	const { showAddVeranstaltungArea, keineVeranstaltungen, setShowAddVeranslatungsPanel } = props
	// Abgeleitet, nicht im Store: bei leerer Liste gibt es hier nichts anderes zu tun, ein
	// zusaetzlicher Klick waere Zeremonie. Als Ableitung kann das nicht mit dem Store
	// auseinanderlaufen und landet auch nicht im localStorage.
	const formularOffen = showAddVeranstaltungArea || keineVeranstaltungen;
	return (
		<div className="container">
			<EIVHeader></EIVHeader>
			<div className="h3">Meine Veranstaltungen</div>
			<div className={CSS_CLASSNAME_PANEL}>
				{/* Ohne vnr: hier zaehlt die Summe ueber alle Veranstaltungen. */}
				<SpeichermodusHinweis kontext="liste" />
				{/* Hinzufuegen steht ueber der Liste: darunter lag es bei mehreren Veranstaltungen
				    ausserhalb des Sichtfelds - auch fuer den, den der Portal-Link genau hierher
				    schickt (applyVNR). Genau ein Ort, nichts doppelt. */}
				{!formularOffen &&
					<Button color="secondary" className="mb-3" aria-expanded="false"
						onClick={() => setShowAddVeranslatungsPanel(true)} >Veranstaltung hinzufügen</Button>
				}
				{formularOffen &&
					<AddVeranstaltungPanel zuklappbar={!keineVeranstaltungen}
						toggleAddVNRPanel={() => setShowAddVeranslatungsPanel(false)}>
					</AddVeranstaltungPanel>
				}
				<Veranstaltungen />
			</div>


		</div>
	)
}
const mapStateToProps = (state, ownProps) => {
	return {
		showAddVeranstaltungArea: state.addVeranstaltungPanel.showAddVeranstaltungArea,
		keineVeranstaltungen: Object.keys(state.veranstaltungen || {}).length === 0
	}
}
const putActionsToProps = dispatch => {
	return {
		setScreen: (screen) => dispatch(setScreen(screen)),
		changeVNR: vnr => dispatch(addVeranstaltungPanelSetVNR(vnr)),
		changeVNRPwd: vnrpwd => dispatch(addVeranstaltungPanelSetVNRPwd(vnrpwd)),
		setShowAddVeranslatungsPanel: flag => dispatch(setShowAddVeranslatungsPanel(flag))
	}
};

export default connect(mapStateToProps, putActionsToProps)(VeranstalterPage);
